import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { CreateResult } from "../models/create-result";
import {CustomTagParticipantLinkViewModel} from "../models/card-set-participant-link";

@Injectable({
  providedIn: 'root'
})
export class CardSetService {

  constructor(private _httpService: HttpService) {
  }

  public async GetCardSetsByParticipantId(id: number): Promise<CustomTagParticipantLinkViewModel[]> {

    const httpResult = await this._httpService.apiGet<CustomTagParticipantLinkViewModel[]>(`cardSet/GetCardSetsByParticipantId/${id}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async UpdateCardSets(cardSets: CustomTagParticipantLinkViewModel[]): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`cardSet/UpdateCardSets`, cardSets);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteCardSetsByParticipantId(id: number): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`cardSet/DeleteCardSets/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }
}
